import { directiveResolveParams, moveElementTo, formDataToObject } from '../util';
import {Modal} from "bootstrap";
import {useLangStore} from "../stores/lang.js";

export default {
    // called before bound element's attributes
    // or event listeners are applied
    created(el, binding, vnode, prevVnode) {},
    // called right before the element is inserted into the DOM.
    beforeMount(el, binding, vnode, prevVnode) {},
    // called when the bound element's parent component
    // and all its children are mounted.
    mounted(el, binding, vnode, prevVnode) {
        let filters = formDataToObject(new FormData(el))
        delete filters.date;
        let targetSelector = directiveResolveParams(el, binding, 'target');
        let actionUrl = directiveResolveParams(el, binding, 'action');
        const target = document.querySelector(targetSelector);
        const radioPrices = el.querySelectorAll('input[name="estSejour"]');
        const elmDate = el.querySelector('.date');

        const modalEl = document.getElementById('mapModal')
        //const bootstrapModal = new Modal(modalEl);
        const bootstrapModal = window.Modal.getOrCreateInstance(modalEl);
        let indexes = [];

        const buildInfosOrder = () => {
            indexes = [];
            target.querySelectorAll('.card-details').forEach((elm) => {
                let indexData = JSON.parse(elm.dataset['index']);
                indexes.push(indexData);
            });
        }

        const orderList = (order) => {
            switch (order) {
                case 'price-asc':
                    indexes.sort((a, b) => a.price - b.price);
                    break;
                case 'price-desc':
                    indexes.sort((a, b) => b.price - a.price);
                    break;
                case 'rate-desc':
                    indexes.sort((a, b) => b.avis - a.avis);
                    break;
                case 'title-asc':
                    indexes.sort((a, b) => a.title.localeCompare(b.title));
                    break;
                default:
                    indexes.sort((a, b) => a.recommend - b.recommend);
                    break;
            }
        }


        const rebuildListByOrder = () => {
            const listElm = target.querySelector('.products-list-content')
            indexes.forEach((index) => {
                let card = target.querySelector(`.card-details[data-id='${index.id}']`);
                listElm.appendChild(card);
            });
        }

        if(radioPrices.length) {
            radioPrices.forEach((radioPrice) => {
                radioPrice.addEventListener('change', function (event) {
                    if (elmDate) {
                        if (radioPrice.value == 0) {
                            window.document.querySelector('#formFilters').setAttribute('data-display-date', 'nightprice');
                            el.insertBefore(elmDate, el.querySelector('.weekprice'))
                            elmDate.querySelector('.estSejour1').classList.toggle('d-none');
                            elmDate.querySelector('.estSejour0').classList.toggle('d-none');
                        } else {
                            window.document.querySelector('#formFilters').setAttribute('data-display-date', 'weekprice');
                            el.insertBefore(elmDate, el.querySelector('.standing'))
                            elmDate.querySelector('.estSejour1').classList.toggle('d-none');
                            elmDate.querySelector('.estSejour0').classList.toggle('d-none');
                        }
                    }
                });
            });
        }

        const updateDataFilters = () => {
            const productsListContent = document.querySelector('.products-list-content');

            if (productsListContent) {
                productsListContent.setAttribute('data-filters-price', filters.estSejour === 0 ? 'bynight' : 'byweek');
                productsListContent.setAttribute('data-filters-currency', 'eur');
                productsListContent.setAttribute('data-filters-category', 'hotel');
            }
        };

        const updateCounterFilters = () => {
            const toInt = ['nombreChambres', 'nombreVoyageurs'];
            let formData = new FormData(el);
            let params = formDataToObject(formData);
            if(!params.date){
                delete params.date;
            }
            toInt.forEach((key) => {
                if(params[key]){
                    params[key] = parseInt(params[key]);
                }
            });

            // Display total of filter selected
            const filterSelectedElm = document.querySelectorAll('.filterSelected');
            let filterSelected = 0;

            if(filterSelectedElm){
                for (const key in params) {
                    if (key.startsWith('id')) {
                        const value = params[key];
                        if (Array.isArray(value)) {
                            filterSelected += value.length;
                        }
                    }
                }
               filterSelectedElm.forEach((filterTotal) => {
                    if(filterTotal) {
                        if(filterSelected > 0){
                            filterTotal.innerHTML = '(<span class="strong">' + filterSelected + '</span>)';
                        } else {
                            filterTotal.innerHTML = '';
                        }
                    }
                });
            }
        };

		const href = () => {
			// Enable obfuscation link
			let links = Array.prototype.slice.call(
				document.querySelectorAll('[data-href]')
			);

			links.forEach(function (link) { // Utilisez 'link' au lieu de 'links' ici
				let link_href = link.dataset.href;
				let link_target = link.dataset.target || '_self';

				link.addEventListener('click', function(event) {
					window.location.href = link_href;
				});
			});
		};

        // Event Modal Map
        modalEl.addEventListener('shown.bs.modal', event => {
            setTimeout(() => {
                const map = document.querySelector('#mapModal .map');
                if(map){
                    map.dispatchEvent(new CustomEvent('init', { detail: { filters: filters } }));
                }
            }, 50);
        })

        // Event Modal Filter/Order
        const modalFilterEl = document.getElementById('filterModal')
        const bootstrapModalFilter = new Modal(modalFilterEl);

        modalFilterEl.addEventListener('hidden.bs.modal', event => {
            moveElementTo(document.querySelector('.modal-filters .modal-body .form-filters'), document.querySelector('.form-layout .container') );
            toggleReadMore('close');
        });
        modalFilterEl.addEventListener('shown.bs.modal', event => {
            const urlParams = new URLSearchParams(window.location.search);
            const modalPush = document.querySelector('.form-layout .form-filters');
            const modalPull = document.querySelector('.modal-filters .modal-body .container');

            // Wich display
            /*
            const modalWrapper = document.querySelector('.modal-filters');
            let displayContent = urlParams.get('display') || 'filter';
            if( displayContent ) {
                modalWrapper.setAttribute('data-display', displayContent);
            }*/

            // Update DOM
            if( modalPush !== null && modalPull !== null ) {
                moveElementTo(modalPush, modalPull);
            }
        });

        const displayFilter = (display) => {
            const urlParams = new URLSearchParams(window.location.search);
            const modalWrapper = document.querySelector('.modal-filters');

            // Update Url
            urlParams.delete('display');
            urlParams.set('display', display);
            //history.pushState(null, '', window.location.pathname + window.location.hash + `?display=${display}`);
            history.pushState(null, '', window.location.pathname + window.location.hash);

            // Update DOM
            modalWrapper.setAttribute('data-display', display);
        }

        const syncFilterOrder = (value) => {
            const dropDownFilter = document.querySelectorAll('.dropdown-menu .list-order');
            const modalMenuFilter = document.querySelectorAll('.form-check-list .list-order');

            dropDownFilter.forEach((dropDown) => {
                if(dropDown.value === value){
                    dropDown.checked = true;
                } else {
                    dropDown.checked = false;
                }
            });

            modalMenuFilter.forEach((modalMenu) => {
                if(modalMenu.value === value){
                    modalMenu.checked = true;
                } else {
                    modalMenu.checked = false;
                }
            });
        }

        const toggleReadMore = (state) => {
            const filterListWrapper = document.querySelectorAll('.form-filters .form-check-list');

            filterListWrapper.forEach(list => {
                if(state == 'open') {
                    list.classList.remove('with-read-more');
                } else {
                    list.classList.add('with-read-more');
                }
            });
        }


        let displayMapElm = null;

        const init = () => {

            const actionDisplayFilter = document.querySelector(directiveResolveParams(el, binding, 'displayFilter'));
            const actionDisplayOrder = document.querySelector(directiveResolveParams(el, binding, 'displayOrder'));
            const actionDisplayMap = document.querySelector(directiveResolveParams(el, binding, 'displayMap'));
            const dropDownFilter = document.querySelectorAll('.dropdown-menu .list-order');
            const modalOrderFilter = document.querySelectorAll('.form-check-list .list-order');
            displayMapElm = actionDisplayMap.querySelector('div.picture');

            const displayMapLauncher = document.querySelector('.maps-launcher .picture');
            const displayMapButton = document.querySelector('.launcher-btn.map');

            buildInfosOrder();
            updateCounterFilters();

            actionDisplayFilter.addEventListener('click', function (event) {
                displayFilter('filters');
                bootstrapModalFilter.show();
                toggleReadMore('open');
            })

            actionDisplayOrder.addEventListener('click', function (event) {
                displayFilter('order');
                bootstrapModalFilter.show();
            })

            displayMapButton.addEventListener('click', function (event) {
                event.preventDefault();
                bootstrapModal.show();
            });

            if(dropDownFilter.length) {
                dropDownFilter.forEach((dropDown) => {
                    dropDown.addEventListener('click', function (event) {
                        orderList(event.target.value);
                        syncFilterOrder(event.target.value);
                        rebuildListByOrder();
                    });
                });
            }

            if(modalOrderFilter.length) {
                modalOrderFilter.forEach((modalOrder) => {
                    modalOrder.addEventListener('click', function (event) {
                        syncFilterOrder(event.target.value);
                    });
                });
            }
        }

        // Créé une instance de l'observateur lié à la fonction de callback
        let observer = new MutationObserver(()=>{
            init();
            updateDataFilters();
            href();
        });
        observer.observe(target, {childList: true});


        const submitForm = async (e) => {
            const toInt = ['nombreChambres', 'nombreVoyageurs'];
            let formData = new FormData(el);
            let params = formDataToObject(formData);
            if(!params.date){
                delete params.date;
            }
            toInt.forEach((key) => {
                if(params[key]){
                    params[key] = parseInt(params[key]);
                }
            });

            filters = params;
            const response = await axios.get(actionUrl, { params: params });
            target.innerHTML = response.data.html;
            displayMapElm.innerHTML = response.data.mapImage.pictureHtml


            document.querySelector('#formFilters').dispatchEvent(new CustomEvent('submitted', {detail: {filters: filters}}));
        }
        el.addEventListener('change', function (event) {
            if(event.target.classList.contains('list-order')) {
                orderList(event.target.value);
                rebuildListByOrder();
            } else {
                submitForm();
            }
            updateCounterFilters();
        });

        init();
    },
    // called before the parent component is updated
    beforeUpdate(el, binding, vnode, prevVnode) {},
    // called after the parent component and
    // all of its children have updated
    updated(el, binding, vnode, prevVnode) {},
    // called before the parent component is unmounted
    beforeUnmount(el, binding, vnode, prevVnode) {},
    // called when the parent component is unmounted
    unmounted(el, binding, vnode, prevVnode) {}
}
